import { BaseService } from "@ucchub/ui/src/BaseService";
import environment from "environment";
import { useEffect, useState } from "react";

interface manageAccess {
  manageUsers: boolean;
  manageRoles: boolean;
  manageCustomers: boolean;
}

const useCustomerPermissions = () => {
  const [isPermissionLoading, setIsPermissionLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [permissions, setPermissions] = useState<manageAccess>();

  const fetchCustomerPermissions = async () => {
    const url = `${environment.api.permissions}`;
    await BaseService.get(url)
      .then((data) => {
        const manageAccess = data.data.attributes[0].permissions;
        setIsPermissionLoading(false);
        setPermissions({
          manageUsers: manageAccess[0].level !== 2 ? true : false,
          manageRoles: manageAccess[0].level !== 2 ? true : false,
          manageCustomers: manageAccess[0].level !== 2 ? true : false,
        });
      })
      .catch((err) => {
        setIsPermissionLoading(false);
        setError(err.response.data.message || err);
      })
      .finally(() => {
        setIsPermissionLoading(false);
      });
  };
  useEffect(() => {
    fetchCustomerPermissions();
  }, []);

  return { permissions, isPermissionLoading, error, fetchCustomerPermissions };
};
export default useCustomerPermissions;
